<template>
  <v-container grid-list-xl>
    <DeclinedPaymentReceipt
      v-if="showDialog"
      :showDialog="showDialog"
      v-on:hide="hide"
      :receiptImageSrc="receiptImageSrc"
      :receiptImageIsLoading="receiptImageIsLoading"
    />
    <v-row class="my-5">
      <v-col cols="12" md="12">
        <v-card>
          <v-flex>
            <div class="autopilot-button-container">
              <v-btn
                color="primary"
                @click="openAutoPilot"
                :loading="autoPilotSwitch"
                :disabled="autoPilotSwitch"
              >
                Click Here To See A Declined Payment
                <template v-slot:loader>
                  <span>Waiting for receipts ({{remainingTime}})</span>
                </template>
              </v-btn>
              <countdown
                v-if="autoPilotSwitch && !showDialog"
                :time="countDown"
                :interval="1000"
                @end="autoPilot()"
                @progress="handleCountdownProgress"
              >
                <v-progress-linear :value="progress" color="blue accent-4"></v-progress-linear>
              </countdown>
            </div>
            <v-switch v-model="autoPilotSwitch" label="Autopilot" @click.native="turnCountDownBackToDefault" ></v-switch>
          </v-flex>
        </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import DeclinedPaymentReceipt from "../components/DeclinedPaymentReceipt";

export default {
  components: {
    DeclinedPaymentReceipt
  },
  data() {
    return {
      showDialog: false,
      receiptImageSrc: '',
      receiptImageIsLoading: true,
      countDown: 5000, // DEFAULT COUNTDOWN TIME
      secondsLeft: 0,
      autoPilotSwitch: false,
      progress: 0,
      autoPilotIntervalDefault: 5000,
    };
  },
  computed: {
    ...mapGetters(["selectedDashboard"]),
    remainingTime() {
      return ((this.countDown / 1000) * this.progress) / 100;
    },
  },
  methods: {
    ...mapActions(["getDeclinedPaymentReceipt"]),
    ...mapMutations(["setCurrentReceipt"]),
    hide(options) {
      this.showDialog = false;
      if (options && options.autopilot) {
        this.openAutoPilot()
      }
    },
    autoPilot() {
      this.autoPilotSwitch = true;
      this.getDeclinedPaymentReceipt().then(res => {
        this.receiptImageIsLoading = true;
        this.setCurrentReceipt(res.receipt);
        this.receiptImageSrc = res.receipt.receiptImageURL;
        this.autoPilotSwitch = false;
        this.showDialog = true;
      }).catch(err => {
        this.autoPilotSwitch = false;
      }).finally(() => {
        this.receiptImageIsLoading = false;
      });
    },
    openAutoPilot() {
      this.autoPilotSwitch = true;
    },
    handleCountdownProgress(data) {
      this.secondsLeft = data.totalSeconds;
      this.progress = Math.floor(
        (100 * this.secondsLeft) / (this.countDown / 1000)
      );
    },
    turnCountDownBackToDefault() {
      this.countDown = this.autoPilotIntervalDefault;
    }
  }
};
</script>
